import React from 'react';
import { instanceOf, func } from 'prop-types';
import DefinitionTableBodyRow from './DefinitionTableBodyRow';

const DefinitionTableBody = ({ data = null, setSelectedDefinition }) => {
  const _handleOnRowSelect = (checkSate, row) => {
    setSelectedDefinition(checkSate, row, data.id);
  };
  return (
    <div className="de--def--table__body de--flex-col-1 datahub-table--body">
      {data &&
        data.data.map(item => (
          <DefinitionTableBodyRow
            item={item}
            key={item.ui}
            onRowSelect={_handleOnRowSelect}
          />
        ))}
    </div>
  );
};

DefinitionTableBody.propTypes = {
  data: instanceOf(Object),
  setSelectedDefinition: func,
};

export default DefinitionTableBody;
